import { render, staticRenderFns } from "./EducationDevelopmentPlanPage.vue?vue&type=template&id=44e5bfe0&scoped=true"
import script from "./EducationDevelopmentPlanPage.vue?vue&type=script&lang=js"
export * from "./EducationDevelopmentPlanPage.vue?vue&type=script&lang=js"
import style0 from "./EducationDevelopmentPlanPage.vue?vue&type=style&index=0&id=44e5bfe0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e5bfe0",
  null
  
)

export default component.exports